function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getLocale } from 'researcher/application/reducer';
import { CHINA_ID } from 'researcher/domain/account/country';
import InstitutionForm, { defaultValues as institutionDefaultValues } from 'shared/account/components/InstitutionForm';
import { T, useTranslate } from 'shared/helper/translate';
import { Controls, validators, useFormHelpers } from 'shared/helper/form';
import { PASSWORD_MIN_LENGTH } from 'shared/helper/form/validators';
import { convertJsonToUserInformationFormData, convertFormDataToUserUpdateRequest } from 'shared/view/user-conversion-service';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
import Orcid from './Orcid';
// import AdminUserInformationForm from './AdminUserInformationFormContainer';
import LocalizationPreferences from './LocalizationPreferences';
var Form = Controls.Form,
  Text = Controls.Text,
  Select = Controls.Select,
  Checkbox = Controls.Checkbox,
  Password = Controls.Password,
  MultiFieldValidation = Controls.MultiFieldValidation;
var marketingMessage = 'Check this box if you’d like to receive news, special offers and updates by email.';
var isEmail = validators.isEmail,
  notEmpty = validators.notEmpty,
  notFalse = validators.notFalse,
  validPassword = validators.validPassword;
var defaultStyles = {
  form: '',
  controls: 'col-md-12',
  description: 'help-block col-md-12',
  error: 'col-md-12 error',
  label: 'col-md-12',
  submit: 'mb-3 float-end',
  wrapper: 'mb-3 row',
  nameFields: {
    wrapper: 'mb-3',
    controlWrapper: 'col-md-6 col-12',
    groupWrapper: 'row'
  }
};
var defaultValues = {
  active: true,
  addedToWatchlist: false,
  agreeToTOS: false,
  companySelection: {
    value: null
  },
  country: null,
  creditNotesLocked: false,
  currency: {
    value: null
  },
  currencySelectionDisabled: false,
  email: '',
  excludeFromDelinquentCheck: false,
  firstName: '',
  foundUs: '',
  institution: institutionDefaultValues,
  language: {
    value: null
  },
  lastName: '',
  localization: '',
  optinToMarketing: false,
  orcid: '',
  otherFoundUs: '',
  overrideDownloadAvailable: false,
  password: '',
  phoneNumber: '',
  secondaryEmail: '',
  title: '',
  watchlistNotification: '',
  workplace: ''
};
var emailsMatch = function emailsMatch(skipConfirmationEmail) {
  return function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      email = _ref2[0],
      confirmEmail = _ref2[1];
    return skipConfirmationEmail || email === confirmEmail;
  };
};
var UserInformationForm = function UserInformationForm(_ref3) {
  var displayPassword = _ref3.displayPassword,
    fields = _ref3.fields,
    _ref3$findPreferredGr = _ref3.findPreferredGroups,
    findPreferredGroups = _ref3$findPreferredGr === void 0 ? function () {} : _ref3$findPreferredGr,
    formData = _ref3.formData,
    persistData = _ref3.persistData,
    processingProp = _ref3.processing,
    stylesProp = _ref3.styles,
    _ref3$testAttribute = _ref3.testAttribute,
    testAttribute = _ref3$testAttribute === void 0 ? null : _ref3$testAttribute,
    userIdentity = _ref3.userIdentity;
  var submitButton = useRef();
  var methods = useForm({
    defaultValues: defaultValues
  });
  var _useFormHelpers = useFormHelpers(methods),
    populateFormData = _useFormHelpers.populateFormData;
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  var countries = useSelector(function (_ref4) {
    var account = _ref4.account;
    return account.countries;
  });
  var currencies = useSelector(function (_ref5) {
    var account = _ref5.account;
    return account.currencies;
  });
  var currentLocalization = useSelector(function (_ref6) {
    var application = _ref6.application;
    return application.currentLocalization;
  });
  var enforcesDataProtection = useSelector(function (_ref7) {
    var application = _ref7.application;
    return application.config.enforcesDataProtection;
  });
  var foundUsOptions = useSelector(function (_ref8) {
    var application = _ref8.application;
    return application.config.foundUsOptions;
  });
  var institutionInfoMandatory = useSelector(function (_ref9) {
    var application = _ref9.application;
    return application.config.institutionInfoMandatory;
  });
  var localizations = useSelector(function (_ref10) {
    var application = _ref10.application;
    return application.localizations;
  });
  var languages = useSelector(function (_ref11) {
    var account = _ref11.account;
    return account.languages;
  });
  var missingFields = useSelector(function (_ref12) {
    var user = _ref12.user;
    return (user === null || user === void 0 ? void 0 : user.missingFields) || [];
  });
  var loaded = useSelector(function (_ref13) {
    var account = _ref13.account;
    return account.status.loaded;
  });
  var _useSelector = useSelector(getLocale),
    siteLanguage = _useSelector.iso639Locale;
  var titles = useSelector(function (_ref14) {
    var account = _ref14.account;
    return account.titles;
  });
  var curie = useSelector(function (_ref15) {
    var curie = _ref15.curie;
    return curie;
  });
  useEffect(function () {
    if (formData) {
      populateFormData(convertJsonToUserInformationFormData(formData, {
        currencies: currencies,
        countries: countries,
        foundUsOptions: foundUsOptions,
        currentLocalization: currentLocalization
      }));
    }
  }, [formData && formData.identity, formData && formData.countryId]);
  useEffect(function () {
    if (missingFields.length > 0 && userIdentity) {
      submitButton.current.click();
    }
  }, [missingFields]);
  useEffect(function () {
    methods.setValue('optinToMarketing', !countryEnforcesDataProtection && !enforcesDataProtection);
  }, [countryEnforcesDataProtection, enforcesDataProtection]);
  var _methods$watch = methods.watch(['addedToWatchlist', 'companySelection', 'country', 'currencySelectionDisabled', 'foundUs']),
    _methods$watch2 = _slicedToArray(_methods$watch, 5),
    addedToWatchlist = _methods$watch2[0],
    companySelection = _methods$watch2[1],
    country = _methods$watch2[2],
    currencySelectionDisabled = _methods$watch2[3],
    foundUs = _methods$watch2[4];
  var isProfileForm = !!userIdentity;
  var processing = processingProp || !loaded || isProfileForm && !fields.admin && !curie.loaded;
  var styles = _objectSpread(_objectSpread({}, defaultStyles), stylesProp);

  // just some custom styling for the Paddle subscription message below the email input
  var curieStyles = _objectSpread(_objectSpread(_objectSpread({}, defaultStyles), stylesProp), {}, {
    controlClass: 'mb-2',
    description: 'help-block col-md-12 mt-0'
  });
  var handlePersistData = function handlePersistData(submittedFormData) {
    var originalData = convertJsonToUserInformationFormData(formData || {}, {
      currencies: currencies,
      countries: countries,
      foundUsOptions: foundUsOptions,
      currentLocalization: currentLocalization
    });
    var changedFields = {};
    var changedFieldNames = [];
    Object.keys(submittedFormData).forEach(function (key) {
      var _oldValue$value, _newValue$value;
      var oldValue = originalData === null || originalData === void 0 ? void 0 : originalData[key];
      var newValue = submittedFormData === null || submittedFormData === void 0 ? void 0 : submittedFormData[key];
      var normalizedOld = _typeof(oldValue) === 'object' && oldValue !== null ? (_oldValue$value = oldValue.value) !== null && _oldValue$value !== void 0 ? _oldValue$value : oldValue.label : oldValue;
      var normalizedNew = _typeof(newValue) === 'object' && newValue !== null ? (_newValue$value = newValue.value) !== null && _newValue$value !== void 0 ? _newValue$value : newValue.label : newValue;
      if (normalizedOld !== normalizedNew) {
        changedFields[key] = {
          from: normalizedOld,
          to: normalizedNew
        };
        changedFieldNames.push(key);
      }
    });
    trackRubriqEvent('User Information Updated', {
      changed_fields: changedFieldNames,
      changed_count: changedFieldNames.length,
      changes: changedFields
    });
    if (changedFields.email) {
      trackRubriqEvent('Primary Email Updated', {
        from: changedFields.email.from,
        to: changedFields.email.to,
        userId: userIdentity === null || userIdentity === void 0 ? void 0 : userIdentity.id
      });
    }
    if (changedFields.secondaryEmail) {
      trackRubriqEvent('Secondary Email Updated', {
        from: changedFields.secondaryEmail.from,
        to: changedFields.secondaryEmail.to,
        userId: userIdentity === null || userIdentity === void 0 ? void 0 : userIdentity.id
      });
    }
    persistData(convertFormDataToUserUpdateRequest(submittedFormData, {
      currencies: currencies,
      languages: languages
    }));
  };
  var countryEnforcesDataProtection = country && country.enforcesDataProtection;
  var isChinaSelected = (country === null || country === void 0 ? void 0 : country.value) === CHINA_ID;
  var phoneNumber = methods.watch('phoneNumber');
  var filterOutCnyConditionally = function filterOutCnyConditionally(currencies) {
    return currencies.filter(function (currency) {
      if ((country === null || country === void 0 ? void 0 : country.value) !== CHINA_ID && !fields.admin) {
        if (currency.value !== 'CNY') {
          return true;
        }
      } else {
        return true;
      }
      return false;
    });
  };
  var handlePhoneBlur = function handlePhoneBlur() {
    trackRubriqEvent('Entered Phone Number', {
      number_existed: !!phoneNumber && phoneNumber.trim() !== ''
    });
  };
  return /*#__PURE__*/React.createElement(Form, {
    className: styles.form,
    methods: methods,
    id: "UserInformationForm",
    onSubmit: handlePersistData,
    testAttribute: testAttribute
  }, !fields.additionalContactInformation ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    label: "Email address",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: isProfileForm && !fields.admin && curie.plan.paddleSubscription ? curieStyles : styles,
    description: isProfileForm && !fields.admin && curie.plan.paddleSubscription ? function () {
      return /*#__PURE__*/React.createElement(T.md, {
        source: "curie.account-email-description",
        useLink: true,
        params: {
          curiePlanLink: '/rubriq/plan'
        }
      });
    } : null
  }), fields.emailConfirmation ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MultiFieldValidation, {
    name: "emailConfirmationValid",
    messages: {
      emailsMatch: 'emailAddressConfirmNotMatch'
    },
    validators: {
      emailsMatch: emailsMatch(!fields.emailConfirmation)
    },
    fields: ['email', 'confirmEmail']
  }), /*#__PURE__*/React.createElement(Text, {
    label: "Confirm email address",
    name: "confirmEmail",
    validators: {
      isEmail: isEmail
    },
    styles: styles,
    required: true
  })) : null) : null, fields.title ? /*#__PURE__*/React.createElement(Select, {
    label: "Title",
    name: "title",
    options: titles,
    sort: true,
    styles: styles
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.nameFields.groupWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.nameFields.controlWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    label: "First name",
    name: "firstName",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles.nameFields
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.nameFields.controlWrapper
  }, /*#__PURE__*/React.createElement(Text, {
    label: "Last name",
    name: "lastName",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles.nameFields
  }))), fields.additionalContactInformation ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    label: "Email address",
    messages: {
      isEmail: 'emailAddressInvalidFormat'
    },
    name: "email",
    validators: {
      isEmail: isEmail
    },
    styles: isProfileForm && !fields.admin && curie.plan.paddleSubscription ? curieStyles : styles,
    description: isProfileForm && !fields.admin && curie.plan.paddleSubscription ? function () {
      return /*#__PURE__*/React.createElement(T.md, {
        source: "curie.account-email-description",
        useLink: true,
        params: {
          curiePlanLink: '/rubriq/plan'
        }
      });
    } : null
  }), /*#__PURE__*/React.createElement(Text, {
    label: "Secondary email",
    name: "secondaryEmail",
    styles: styles,
    maxLength: 191
  }), /*#__PURE__*/React.createElement(Text, {
    label: "Phone number",
    name: "phoneNumber",
    styles: styles,
    maxLength: 191,
    readOnly: isChinaSelected,
    onBlur: handlePhoneBlur
  })) : null, displayPassword ? /*#__PURE__*/React.createElement(Password, {
    label: "Password",
    messages: {
      validPassword: function validPassword() {
        return /*#__PURE__*/React.createElement(T, {
          source: "password-too-short",
          params: PASSWORD_MIN_LENGTH
        });
      }
    },
    name: "password",
    validators: {
      validPassword: validPassword
    },
    styles: styles
  }) : null, /*#__PURE__*/React.createElement(LocalizationPreferences, {
    allowFilterUpdates: !fields.admin && !userIdentity,
    countries: countries,
    currencies: filterOutCnyConditionally(currencies),
    currencySelectionDisabled: currencySelectionDisabled,
    currentLocalization: currentLocalization,
    fields: fields.localizationPreferencesFields,
    languages: languages,
    localizations: localizations,
    methods: methods,
    siteLanguage: siteLanguage,
    styles: styles
  }), fields.foundUs && foundUsOptions.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
    label: "How did you hear about us?",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "foundUs",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    options: foundUsOptions.map(function (option) {
      return {
        label: option,
        value: option
      };
    })
  }), foundUs && foundUs.value.toLowerCase() === 'other website' ? /*#__PURE__*/React.createElement(Text, {
    label: "Other Website (please specify)",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "otherFoundUs",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    maxLength: 191
  }) : null) : null, fields.orcid ? /*#__PURE__*/React.createElement(Orcid, {
    styles: styles
  }) : null, fields.marketingOptIn ? /*#__PURE__*/React.createElement(Checkbox, {
    label: marketingMessage,
    name: "optinToMarketing",
    styles: styles
  }) : null, fields.tosSelectionRequired ? /*#__PURE__*/React.createElement(Checkbox, {
    label: (country === null || country === void 0 ? void 0 : country.value) === CHINA_ID ? 'tos-china' : 'tos-checkbox',
    messages: {
      notFalse: 'tos-validation-error'
    },
    name: "agreeToTOS",
    styles: styles,
    validators: {
      notFalse: notFalse
    },
    required: true
  }) : null, translationExists('registration-personal-info-disclaimer') ? /*#__PURE__*/React.createElement("div", {
    className: "disclaimer-text"
  }, /*#__PURE__*/React.createElement(T, {
    source: "registration-personal-info-disclaimer"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.submit, " async-form-submission mt-3")
  }, fields.submit.alignment === 'right' && processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: processing,
    className: "btn btn-primary btn-squared",
    ref: submitButton,
    "data-cy": "submit",
    "data-track": "click",
    "data-track-action": "button click",
    "data-track-label": "register account"
  }, /*#__PURE__*/React.createElement(T, {
    source: fields.submit.text
  })), fields.submit.alignment === 'left' && processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null));
};
export default UserInformationForm;